var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTnw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 36,
    viewBox: "0 0 149 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_3437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5398 11.25C75.0732 13.7811 76.4977 17.2147 76.5 20.7959V36H63V22.6597C62.9977 21.4655 62.5214 20.321 61.6757 19.4777L57.0129 14.8179C56.1677 13.974 55.0222 13.4999 53.8278 13.5H49.5V36H36V0H55.6918C57.4646 -2.54877e-06 59.2201 0.34919 60.858 1.02764C62.4959 1.70609 63.9842 2.70051 65.2378 3.95413L72.5398 11.25ZM135 0V13.3403C134.998 14.5345 134.521 15.6789 133.676 16.5222L129.01 21.1819C128.592 21.5998 128.096 21.9313 127.55 22.1575C127.004 22.3836 126.419 22.5 125.828 22.5H119.343C120.747 20.3255 121.496 17.7926 121.5 15.204V0H108V13.3403C107.998 14.5345 107.521 15.6789 106.676 16.5222L102.01 21.1819C101.592 21.5998 101.096 21.9313 100.55 22.1575C100.004 22.3836 99.4186 22.5 98.8277 22.5H94.5V0H81V36H100.692C104.273 36 107.708 34.5778 110.241 32.0459L114.75 27.5386V36H127.692C131.273 36 134.708 34.5778 137.241 32.0459L144.54 24.7499C147.073 22.2188 148.498 18.7851 148.5 15.204V0H135ZM0 13.5H9V36H22.5V13.5H31.5V0H0V13.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_3437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.5,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnw);
export default __webpack_public_path__ + "static/media/tnw.a10472a3.svg";
export { ForwardRef as ReactComponent };